// 📁 src/api/courses/CourseRoutes.js
import axiosInstance from "../../axiosInstance";
const BASE_URL = "/elearning/courses";

// Lấy danh sách tất cả khóa học (có hỗ trợ lọc và phân trang)
export const getAllCourses = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });

    const res = await axiosInstance.get(`${BASE_URL}?${params.toString()}`);
    return res.data;
  } catch (error) {
    console.error('Lỗi khi lấy danh sách khóa học:', error);
    throw error;
  }
};

// Lấy tất cả các khóa học (không phân trang)
// Lấy danh sách tất cả khóa học (KHÔNG phân trang)
export const getAllCoursesNoPaging = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });

    const res = await axiosInstance.get(`${BASE_URL}/no-paging?${params.toString()}`);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi lấy danh sách khóa học (no-paging):", error);
    throw error;
  }
};

// Lấy danh sách khóa học theo ID môn học
export const getCoursesByCategory = async (categoryId) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}`, {
      params: {
        subject_id: categoryId,
        is_active: true,
        page: 1,
        size: 1000,
      },
    });
    return response.data.records || [];
  } catch (error) {
    console.error("Lỗi khi lấy khóa học theo môn học:", error);
    return [];
  }
};


// =====================================================
// GET – Lấy chi tiết khóa học theo ID
// =====================================================
export const getCourseById = async (courseId) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${courseId}`);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi lấy chi tiết khóa học:", error);
    throw new Error(
      error.response?.data?.message || "Không thể tải chi tiết khóa học"
    );
  }
};


//  Tạo khóa học mới
//  @param {Object} course - Thông tin khóa học
export const createCourse = async (course) => {
  try {
    const res = await axiosInstance.post(BASE_URL, course);
    return res.data;
  } catch (error) {
    console.error('Lỗi khi tạo khóa học:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Lỗi khi tạo khóa học');
  }
};

export const updateCourse = async (courseId, course) => {
  try {
    const res = await axiosInstance.patch(`${BASE_URL}/${courseId}`, course);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi cập nhật khóa học:", error.response?.data || error.message);
    throw new Error(
      error.response?.data?.message || "Lỗi khi cập nhật khóa học"
    );
  }
};

// Xóa khóa học theo ID
export const deleteCourse = async (courseId) => {
  try {
    const res = await axiosInstance.delete(`${BASE_URL}/${courseId}`);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi xóa khóa học:", error);
    throw new Error(error.response?.data?.message || "Không thể xóa khóa học");
  }
};


// =====================================================
// PATCH – Bật / tắt trạng thái khóa học
// =====================================================
export const toggleCourseStatus = async (courseId, is_active) => {
  try {
    const res = await axiosInstance.patch(
      `${BASE_URL}/${courseId}/status`,
      { is_active }
    );
    return res.data;
  } catch (error) {
    console.error("Lỗi khi cập nhật trạng thái khóa học:", error);
    throw error;
  }
};

// Import hàng loạt khóa học từ file Excel (.xlsx, .xls) hoặc CSV
export const importCoursesFromExcel = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const res = await axiosInstance.post(`${BASE_URL}/import`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 120_000,
    });
    return res.data;
  } catch (error) {
    console.error("Error importing courses from file:", error);
    throw error;
  }
};
